import { useMemo } from "react"
import {
  Block,
  Button,
  FlexGrid,
  FlexGridItem,
  LabelSmall,
  ParagraphSmall,
  Plus,
  useStyletron,
  Wallet03,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { selectActiveDeposits, useDappSelector } from "#/redux-state"
import { IS_MEZO_MAINNET, routes } from "#/shared/constants"
import {
  useDepositsTotalUSDValue,
  useStatistics,
  useTotalWalletUSDValue,
} from "#/shared/hooks"
import { separateThousandsWithComma } from "#/shared/utils"
import AvailableTokens from "#/ui/Token/AvailableTokens"

import HomepageMainSectionAssetsItem from "./HomepageMainSectionAssetsItem"

export default function HomepageMainSectionAssetsDeposits() {
  const activeDeposits = useDappSelector(selectActiveDeposits)

  const { totalUSDDepositsValue } = useDepositsTotalUSDValue()
  const { totalWalletUSDValue } = useTotalWalletUSDValue()

  const [css] = useStyletron()

  useStatistics()

  const labelContent = useMemo(() => {
    if (activeDeposits.length > 0) {
      return (
        <ParagraphSmall color="contentSecondary">
          from {activeDeposits.length} deposits
        </ParagraphSmall>
      )
    }

    return (
      <FlexGrid
        alignItems="center"
        flexGridColumnCount={3}
        flexGridColumnGap="scale100"
      >
        <FlexGridItem
          overrides={{
            Block: {
              style: () => ({ flexGrow: 0, width: "auto", height: "22px" }),
            },
          }}
        >
          <Wallet03 size={14} color="black" />
        </FlexGridItem>
        <FlexGridItem
          overrides={{
            Block: {
              style: () => ({ flexGrow: 0, width: "auto" }),
            },
          }}
        >
          <LabelSmall color="contentSecondary">
            ${separateThousandsWithComma(totalWalletUSDValue)}
          </LabelSmall>
        </FlexGridItem>
        <FlexGridItem
          overrides={{
            Block: {
              style: () => ({ flexGrow: 0, width: "auto" }),
            },
          }}
        >
          <ParagraphSmall color="contentSecondary">
            available to deposit
          </ParagraphSmall>
        </FlexGridItem>
      </FlexGrid>
    )
  }, [activeDeposits.length, totalWalletUSDValue])

  return (
    <HomepageMainSectionAssetsItem
      header={
        <AvailableTokens
          tokensToDisplay={
            activeDeposits.length > 0 ? "deposit-tokens" : "available-tokens"
          }
        />
      }
      value={
        <>
          ${" "}
          <Block
            data-attr="deposit_active"
            as="span"
            className={css({
              color: activeDeposits.length > 0 ? "black" : "#A6A6A6",
            })}
          >
            {separateThousandsWithComma(totalUSDDepositsValue)}
          </Block>
        </>
      }
      label={labelContent}
      buttons={
        IS_MEZO_MAINNET
          ? []
          : [
              <Button
                $as={Link}
                data-attr="deposit_cta"
                href={`${routes.DEPOSIT}?tab=new-deposit`}
                size="small"
                startEnhancer={<Plus color="white" size={16} />}
              >
                Deposit
              </Button>,
            ]
      }
    />
  )
}
